<template>
  <div class="100% loginPage" >

    <!--<amplify-authenticator></amplify-authenticator>-->
    <div class="container-fluid">
      <b-row class="justify-content-center">
        
        <!-- REGISTRAZIONE UTENTE -- form signup name -->
        <b-col v-if="!signedIn && !confirmCode" offset-lg="1" offset-xl="2" offset-md="0" offset-sm="1" offset="2" xs="8" xl="3" lg="4" md="4" sm="6" class="col d-flex align-items-center justify-content-center loginPanel"> 
                <b-form class="justify-content-center img-fluid">

                  <!-- form logo -->
                  <div class="d-flex justify-content-center mb-4">
                    <img class="justify-content-center img-fluid" src="/img/logo_new.png">
                  </div>

                  <b-form-group>
                  <!-- form signup name -->
                  <b-row>
                    <b-col cols="12" class="mt-4">
                      <label for="name">{{this.$t("signup.name")}}</label>
                      <b-form-input v-model="name" type="text" :state="validation_name" class="typo-input" />
                      <b-form-invalid-feedback style="max-width:250px" :state="validation_name">{{$t("signup.validation_name")}}</b-form-invalid-feedback>
                    </b-col>
 
                  <!-- form signup surname -->
                    <b-col cols="12" class="mt-4">
                      <label for="surname">{{this.$t("signup.surname")}}</label>
                      <b-form-input v-model="surname" type="text" :state="validation_surname" class="typo-input"/>
                      <b-form-invalid-feedback style="max-width:250px" :state="validation_surname">{{$t("signup.validation_name")}}</b-form-invalid-feedback>
                    </b-col>

                  <!-- form signup if is client -->                 
                    <b-col cols="12" v-if="isClient" class="mt-4">
                          <label>{{this.$t("user_modal.label_people_or_company")}}</label>
                          <b-form-radio class="ml-4 mb-2" v-model="picked" name="PersonComp" value="person">{{$t("user_modal.label_people")}}</b-form-radio>
                          <b-form-radio class="ml-4 mb-2" v-model="picked" name="PersonComp" value="company">{{$t("user_modal.label_company")}}</b-form-radio>
                    </b-col>    
                    
                    <!-- form signup azienda -->  
                    <b-col cols="6" v-if="isClient" class="mt-2">
                          <b-form-group v-if="picked=='company'">
                              <label for="label-business-name" >{{$t("user_modal.label_business_name")}}</label>
                              <b-form-input v-model="userbusinessName" type="text"  class="typo-input" :state="validation_userbusinessName" id="placeholder-installer-business-name"></b-form-input>
                              <b-form-invalid-feedback :state="validation_userbusinessName">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                          </b-form-group>
                    </b-col>    
                    
                    <b-col cols="6"  v-if="isClient" class="mt-2">
                          <b-form-group v-if="picked=='company'">
                              <label for="label-piva" >{{$t("user_modal.label_piva")}}</label>
                              <b-form-input v-model="userPiva" type="text"  class="typo-input" :state="validation_userPiva" id="placeholder-installer-piva" ></b-form-input>
                              <b-form-invalid-feedback :state="validation_userPiva">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                          </b-form-group>
                    </b-col>
                    
                    <b-col cols="12"  v-if="isClient" class="mt-2">
                            <label for="label-phone" >{{$t("user_modal.label_phone")}}</label>
                            <b-form-input v-model="userPhone" type="text" class="typo-input" :state="validation_userPhone" id="placeholder-installer-phone"></b-form-input>
                            <b-form-invalid-feedback :state="validation_userPhone">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                    </b-col>

                    <b-col cols="7"  v-if="isClient" class="mt-2">
                            <label for="label-installer-street" class="ml-2">{{$t("user_modal.label_street")}}</label>
                            <b-form-input v-model="userStreet" type="text"  class="typo-input" :state="validation_userStreet" id="placeholder-installer-street" ></b-form-input>
                            <b-form-invalid-feedback :state="validation_userStreet">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                    </b-col>
                    
                    <b-col cols="5"  v-if="isClient" class="mt-2">
                            <label for="label-installer-number" class="ml-2">{{$t("user_modal.label_number")}}</label>
                            <b-form-input v-model="userNumber" type="text"  class="typo-input" :state="validation_userNumber" id="placeholder-installer-number" ></b-form-input>
                            <b-form-invalid-feedback :state="validation_userNumber">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                    </b-col>

                    <b-col cols="7"  v-if="isClient" class="mt-2">
                            <label for="label-installer-city" class="ml-2">{{$t("user_modal.label_city")}}</label>
                            <b-form-input v-model="userCity" type="text"  class="typo-input" :state="validation_userCity" id="placeholder-installer-city" ></b-form-input>
                            <b-form-invalid-feedback :state="validation_userCity">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                    </b-col>
                    
                    <b-col cols="5"  v-if="isClient" class="mt-2">
                            <label for="label-installer-cap" class="ml-2">{{$t("user_modal.label_cap")}}</label>
                            <b-form-input v-model="userCap" type="text"  class="typo-input" :state="validation_userCap" id="placeholder-installer-cap" ></b-form-input>
                            <b-form-invalid-feedback :state="validation_userCap">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                    </b-col>

                    <b-col cols="7" v-if="isClient" class="mt-2">
                          <label for="label-installer-prov" class="ml-2">{{$t("user_modal.label_prov")}}</label>
                          <b-form-input v-model="userProv" type="text"  class="typo-input" :state="validation_userProv" id="placeholder-installer-prov" ></b-form-input>
                          <b-form-invalid-feedback :state="validation_userProv">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                    </b-col>
                    
                    <b-col cols="5" v-if="isClient" class="mt-2">
                            <label for="label-installer-country" class="ml-2">{{$t("user_modal.label_country")}}</label>
                            <b-form-select v-model="userCountry"  :country="country" :options="selectCountry">
                            <option :value="null">{{$t("user_modal.placeholder_country")}}</option>
                            </b-form-select>  
                    </b-col>
                 
                 <!-- form signup email -->
                    <b-col cols="12" class="mt-2">
                      <label for="email">{{this.$t("signup.email")}}</label>
                      <b-form-input v-model="email" type="text" :state="validation_email" class="typo-input"/>
                      <b-form-invalid-feedback style="max-width:250px" :state="validation_email">{{$t("signup.validation_email")}}</b-form-invalid-feedback>
                    </b-col>
                 
                  <!-- form signup password -->
                    <b-col cols="12" class="mt-2">
                      <label for="password">{{this.$t("signup.password")}}</label>
                      <b-form-input v-model="password" type="password" :state="validation_password" class="typo-input"/>
                      <b-form-invalid-feedback style="max-width:440px" :state="validation_password">{{$t("signup.validation_password")}}</b-form-invalid-feedback>
                    </b-col>
       
                  <!-- form signup confirm password -->
                    <b-col cols="12" class="mt-2 mb-2">
                      <label for="confirm password">{{this.$t("signup.confirmpassword")}}</label>
                      <b-form-input v-model="passwordConfirm" type="password" :state="validation_passwordConfirm" class="typo-input"/>
                      <b-form-invalid-feedback style="max-width:250px" :state="validation_passwordConfirm">{{$t("signup.validation_passwordConfirm")}}</b-form-invalid-feedback>
                    </b-col>

                  </b-row>  

                  <!-- Alert da utilizzare in caso di errore nell'inserimento dati nel form -->
                    <b-alert
                      :show="dismissCountDown"
                      dismissible
                      variant="danger"
                      @dismissed="dismissCountDown=0"
                      @dismiss-count-down="countDownChanged">
                    <p>{{ alertMessage }}</p>
                    </b-alert>
                 
                  <!-- Consensi di utilizzo del sito -->
                  <div class="d-flex justify-content-center mb-4">
                    <b-row> 
                  
                      <b-col cols="12">
                      <div class="typo-label ml-1 mt-4">
                        {{$t("signup.registration_intro")}} <a :href="$t('link.privacy_policy_registration')"  target="_blank">Privacy Policy</a> {{$t("signup.16_year")}}
                      </div>
                      </b-col>

                      <b-col cols="1" class="mt-4">
                        <input type="checkbox" id="chk-marketing" v-model="chk_marketing">
                      </b-col>
                      <b-col cols="11" class="mt-4">
                        <label for="checkbox" class="ml-1">{{$t("check_marketing")}}<a :href="$t('link.marketing_diretto')"  target="_blank" class="ml-1">({{$t("signup.approfondisci")}})</a></label>
                      </b-col>
                  
                      <b-col cols="1">
                        <input type="checkbox" id="chk-profile" v-model="chk_profiling">
                      </b-col>
                      <b-col cols="11">
                        <label for="checkbox" class="ml-1">{{$t("check_profiling")}}<a :href="$t('link.marketing_profilazione')"  target="_blank" class="ml-1">({{$t("signup.approfondisci")}})</a></label>
                      </b-col>
                  
                      <b-col cols="1">
                        <input type="checkbox" id="chk-comunication" v-model="chk_thirdParts">
                      </b-col>
                      <b-col cols="11">
                        <label for="checkbox" class="ml-1">{{$t("check_third_parts")}}<a :href="$t('link.marketing_terzi')"  target="_blank" class="ml-1">({{$t("signup.approfondisci")}})</a></label>
                      </b-col>
                  </b-row>
                  </div>

                  <div class="d-flex justify-content-center mb-4">      
                     <b-button pill @click="registrati" variant="primary" class="px-4 but-pill">{{this.$t("signup.title")}}</b-button>
                  </div>
                          
               </b-form-group>

              </b-form>
        </b-col>

        <!-- INSERIMENTO CODICE DI VERIFICA  -->
        <b-col v-if="signedIn" offset-lg="1" offset-xl="2" offset-md="0" offset-sm="1" offset="2" xs="8" xl="3" lg="4" md="4" sm="6" class="col d-flex align-items-center justify-content-center loginPanel"> 

           <b-form>
                <!-- logo -->
                <div class="d-flex justify-content-center mt-5 mb-4">
                    <img class="justify-content-center img-fluid" src="/img/logo_new.png">
                </div>
                
                <!-- codice conferma -->
                <div class="d-flex justify-content-center">
                    <b><p class="typo-title">{{$t("signup.completeReg")}}</p></b>
                </div>
                <div class="d-flex justify-content-center mb-3">    
                    <p>{{this.$t("signup.insertCode")}}</p>
                </div>

                <b-form-group>
                     <label for="codice">{{this.$t("signup.code")}}</label>
                     <b-form-input v-model="code" type="text" :state="validation_code" class="typo-input mb-4"/>
                     <b-form-invalid-feedback style="max-width:250px" :state="validation_code">{{$t("signup.validation_null")}}</b-form-invalid-feedback>
                </b-form-group>

                    <!-- Alert da utilizzare in caso di errore nell'inserimento del codice di conferma -->
                    <b-alert
                          :show="dismissCountDown"
                          dismissible
                          variant="danger"
                          @dismissed="dismissCountDown=0"
                          @dismiss-count-down="countDownChanged">
                        <p>{{ alertMessage }}</p>
                        </b-alert>

                  <div class="d-flex justify-content-center mb-5">      
                     <b-button pill @click="confermaReg" variant="primary" class="px-4 but-pill">{{this.$t("signup.confirmReg")}}</b-button>
                  </div>

            </b-form> 
        </b-col>

         <!-- REGISTRAZIONE CONFERMATA -->
        <b-col v-if="confirmCode" offset-lg="1" offset-xl="2" offset-md="0" offset-sm="1" offset="2" xs="8" xl="3" lg="4" md="4" sm="6" class="col d-flex align-items-center justify-content-center loginPanel"> 

           <b-form>
                <!-- logo -->
                <div class="d-flex justify-content-center mt-5 mb-4">
                    <img class="justify-content-center img-fluid" src="/img/logo_new.png">
                </div>
                
                <!-- registrazione completata -->
                <div class="d-flex justify-content-center mb-3">
                    <img id="icon" src="img/IconCheck.svg"></img>
                </div>
                <div class="d-flex justify-content-center">
                    <b><p class="typo-title">{{$t("signup.registrazioneCompletata")}}</p></b>
                </div>
             
                <div class="d-flex justify-content-center mb-5">      
                     <b-button pill @click="gotoLogin" variant="primary" class="px-4 but-pill">{{this.$t("signup.continuaAccedi")}}</b-button>
                </div>

            </b-form> 
        </b-col>

        <!-- PHOTO BACKGROUND ON RIGHT -->
        <hide-at :breakpoints="{small: 767, medium: 768, large: 1024}" breakpoint="small">
          <b-col sm="12" offset-xl="1" xl="6" lg="7" md="12" class="pull-right">
              <div style="overflow: hidden">
                <img class="img-login" src="/img/login.png" />
              </div>
          </b-col>  
        </hide-at>

      </b-row>
    </div>

  </div>
  
</template>

<script>
import { AmplifyEventBus } from 'aws-amplify-vue'
import { Auth } from 'aws-amplify'
import {showAt, hideAt} from 'vue-breakpoints'

export default {
  name: 'Registrati',
  components: {
    hideAt, showAt
  },
  props: [],
  data() {
      return {
          name:'',
          surname:'',
          email: '',
          password:'',
          passwordConfirm:'',
          userbusinessName:'',
          userPiva:'',
          userPhone:'',
          userStreet:'',
          userNumber:'',
          userCity:'',
          userCap:'',
          userProv:'',
          userCountry:"IT",
          country: null,
          signedIn: false,
          confirmCode: false,
          currUser: null,
          picked:"company",
          selectCountry:[],
          code: '',
          dismissSecs: 5,
          dismissCountDown: 0,
          alertMessage:"",
          chk_marketing:false,
          chk_profiling:false,
          chk_thirdParts:false,
          saveSubmit:false,
          saveReg:false,
          reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
          reg_lowercase: /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,30})$/,
          regex_password: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/  //Minimo 8 caratteri, almeno un numero, un carattere minuscolo, un carattre maiuscolo e un carattere speciale
      }
  },
  computed:{
    isClient()
    {
      if (this.$store.state.invite!=null && this.$store.state.inviteType=="client") return true
      return false 
    },  
    validation_code() {
      if (this.saveReg == true) return this.code.length > 0;
    },
    validation_name() {
      if (this.saveSubmit == true) return (this.name.length > 0 && /^((?![_./]).)*$/.test(this.name));
    },
    validation_surname() {
      if (this.saveSubmit == true) return (this.surname.length > 0 && /^((?![_./]).)*$/.test(this.surname));
    },
    validation_email() {
      if (this.saveSubmit == true) 
      {
        if(this.email.length>0 && this.reg_lowercase.test(this.email))
         return true
        else
         return false 
      }  
    },
    validation_password() {
      if (this.saveSubmit == true) 
      {
        if(this.regex_password.test(this.password))  //Minimo 8 caratteri, almeno un numero, un carattere minuscolo, un carattre maiuscolo e un carattere speciale
          return true
        else
          return false
      }  
  },
    validation_passwordConfirm() {
      if (this.saveSubmit == true) 
      {
        if(this.passwordConfirm.length >= 8 && this.password==this.passwordConfirm)
          return true
        else
          return false
      }  
    },
        validation_userbusinessName() {
                if(this.saveUser==true) return (this.userbusinessName.length > 0 && /^((?![_./]).)*$/.test(this.surname));
            },
        validation_userStreet() {
                if(this.saveUser==true) return this.userStreet.length > 0
            },
        validation_userPiva() {
                if(this.saveUser==true) return this.userPiva.length > 7 && this.userPiva.length < 13
            },
        validation_userPhone() {
                if(this.saveUser==true) return this.userPhone.length > 0
            },
        validation_userNumber() {
                if(this.saveUser==true) return this.userNumber.length > 0
            },
        validation_userCity() {
                if(this.saveUser==true) return this.userCity.length > 0
            },  
        validation_userCap() {
                if(this.saveUser==true) return this.userCap.length > 0
            },   
        validation_userProv() {
                if(this.saveUser==true) return this.userProv.length > 0
            },    
        validation_userCountry() {
                if(this.saveUser==true) return this.userCountry.length > 0
            }
  },
  created (){
   this.setCountry();
  },
  methods: {
    setCountry () {
    var options = [
                    { value:"AF", text:"Afghanistan"},
                    { value:"AX", text:"Åland Islands"},
                    { value:"AL", text:"Albania"},
                    { value:"DZ", text:"Algeria"},
                    { value:"AS", text:"American Samoa"},
                    { value:"AD", text:"Andorra"},
                    { value:"AO", text:"Angola"},
                    { value:"AI", text:"Anguilla"},
                    { value:"AQ", text:"Antarctica"},
                    { value:"AG", text:"Antigua and Barbuda"},
                    { value:"AR", text:"Argentina"},
                    { value:"AM", text:"Armenia"},
                    { value:"AW", text:"Aruba"},
                    { value:"AU", text:"Australia"},
                    { value:"AT", text:"Austria"},
                    { value:"AZ", text:"Azerbaijan"},
                    { value:"BS", text:"Bahamas"},
                    { value:"BH", text:"Bahrain"},
                    { value:"BD", text:"Bangladesh"},
                    { value:"BB", text:"Barbados"},
                    { value:"BY", text:"Belarus"},
                    { value:"BE", text:"Belgium"},
                    { value:"BZ", text:"Belize"},
                    { value:"BJ", text:"Benin"},
                    { value:"BM", text:"Bermuda"},
                    { value:"BT", text:"Bhutan"},
                    { value:"BO", text:"Bolivia, Plurinational State of"},
                    { value:"BQ", text:"Bonaire, Sint Eustatius and Saba"},
                    { value:"BA", text:"Bosnia and Herzegovina"},
                    { value:"BW", text:"Botswana"},
                    { value:"BV", text:"Bouvet Island"},
                    { value:"BR", text:"Brazil"},
                    { value:"IO", text:"British Indian Ocean Territory"},
                    { value:"BN", text:"Brunei Darussalam"},
                    { value:"BG", text:"Bulgaria"},
                    { value:"BF", text:"Burkina Faso"},
                    { value:"BI", text:"Burundi"},
                    { value:"KH", text:"Cambodia"},
                    { value:"CM", text:"Cameroon"},
                    { value:"CA", text:"Canada"},
                    { value:"CV", text:"Cape Verde"},
                    { value:"KY", text:"Cayman Islands"},
                    { value:"CF", text:"Central African Republic"},
                    { value:"TD", text:"Chad"},
                    { value:"CL", text:"Chile"},
                    { value:"CN", text:"China"},
                    { value:"CX", text:"Christmas Island"},
                    { value:"CC", text:"Cocos (Keeling) Islands"},
                    { value:"CO", text:"Colombia"},
                    { value:"KM", text:"Comoros"},
                    { value:"CG", text:"Congo"},
                    { value:"CD", text:"Congo, the Democratic Republic of the"},
                    { value:"CK", text:"Cook Islands"},
                    { value:"CR", text:"Costa Rica"},
                    { value:"CI", text:"Côte d'Ivoire"},
                    { value:"HR", text:"Croatia"},
                    { value:"CU", text:"Cuba"},
                    { value:"CW", text:"Curaçao"},
                    { value:"CY", text:"Cyprus"},
                    { value:"CZ", text:"Czech Republic"},
                    { value:"DK", text:"Denmark"},
                    { value:"DJ", text:"Djibouti"},
                    { value:"DM", text:"Dominica"},
                    { value:"DO", text:"Dominican Republic"},
                    { value:"EC", text:"Ecuador"},
                    { value:"EG", text:"Egypt"},
                    { value:"SV", text:"El Salvador"},
                    { value:"GQ", text:"Equatorial Guinea"},
                    { value:"ER", text:"Eritrea"},
                    { value:"EE", text:"Estonia"},
                    { value:"ET", text:"Ethiopia"},
                    { value:"FK", text:"Falkland Islands (Malvinas)"},
                    { value:"FO", text:"Faroe Islands"},
                    { value:"FJ", text:"Fiji"},
                    { value:"FI", text:"Finland"},
                    { value:"FR", text:"France"},
                    { value:"GF", text:"French Guiana"},
                    { value:"PF", text:"French Polynesia"},
                    { value:"TF", text:"French Southern Territories"},
                    { value:"GA", text:"Gabon"},
                    { value:"GM", text:"Gambia"},
                    { value:"GE", text:"Georgia"},
                    { value:"DE", text:"Germany"},
                    { value:"GH", text:"Ghana"},
                    { value:"GI", text:"Gibraltar"},
                    { value:"GR", text:"Greece"},
                    { value:"GL", text:"Greenland"},
                    { value:"GD", text:"Grenada"},
                    { value:"GP", text:"Guadeloupe"},
                    { value:"GU", text:"Guam"},
                    { value:"GT", text:"Guatemala"},
                    { value:"GG", text:"Guernsey"},
                    { value:"GN", text:"Guinea"},
                    { value:"GW", text:"Guinea-Bissau"},
                    { value:"GY", text:"Guyana"},
                    { value:"HT", text:"Haiti"},
                    { value:"HM", text:"Heard Island and McDonald Islands"},
                    { value:"VA", text:"Holy See (Vatican City State)"},
                    { value:"HN", text:"Honduras"},
                    { value:"HK", text:"Hong Kong"},
                    { value:"HU", text:"Hungary"},
                    { value:"IS", text:"Iceland"},
                    { value:"IN", text:"India"},
                    { value:"ID", text:"Indonesia"},
                    { value:"IR", text:"Iran, Islamic Republic of"},
                    { value:"IQ", text:"Iraq"},
                    { value:"IE", text:"Ireland"},
                    { value:"IM", text:"Isle of Man"},
                    { value:"IL", text:"Israel"},
                    { value:"IT", text:"Italy"},
                    { value:"JM", text:"Jamaica"},
                    { value:"JP", text:"Japan"},
                    { value:"JE", text:"Jersey"},
                    { value:"JO", text:"Jordan"},
                    { value:"KZ", text:"Kazakhstan"},
                    { value:"KE", text:"Kenya"},
                    { value:"KI", text:"Kiribati"},
                    { value:"KP", text:"Korea, Democratic People's Republic of"},
                    { value:"KR", text:"Korea, Republic of"},
                    { value:"KW", text:"Kuwait"},
                    { value:"KG", text:"Kyrgyzstan"},
                    { value:"LA", text:"Lao People's Democratic Republic"},
                    { value:"LV", text:"Latvia"},
                    { value:"LB", text:"Lebanon"},
                    { value:"LS", text:"Lesotho"},
                    { value:"LR", text:"Liberia"},
                    { value:"LY", text:"Libya"},
                    { value:"LI", text:"Liechtenstein"},
                    { value:"LT", text:"Lithuania"},
                    { value:"LU", text:"Luxembourg"},
                    { value:"MO", text:"Macao"},
                    { value:"MK", text:"Macedonia, the former Yugoslav Republic of"},
                    { value:"MG", text:"Madagascar"},
                    { value:"MW", text:"Malawi"},
                    { value:"MY", text:"Malaysia"},
                    { value:"MV", text:"Maldives"},
                    { value:"ML", text:"Mali"},
                    { value:"MT", text:"Malta"},
                    { value:"MH", text:"Marshall Islands"},
                    { value:"MQ", text:"Martinique"},
                    { value:"MR", text:"Mauritania"},
                    { value:"MU", text:"Mauritius"},
                    { value:"YT", text:"Mayotte"},
                    { value:"MX", text:"Mexico"},
                    { value:"FM", text:"Micronesia, Federated States of"},
                    { value:"MD", text:"Moldova, Republic of"},
                    { value:"MC", text:"Monaco"},
                    { value:"MN", text:"Mongolia"},
                    { value:"ME", text:"Montenegro"},
                    { value:"MS", text:"Montserrat"},
                    { value:"MA", text:"Morocco"},
                    { value:"MZ", text:"Mozambique"},
                    { value:"MM", text:"Myanmar"},
                    { value:"NA", text:"Namibia"},
                    { value:"NR", text:"Nauru"},
                    { value:"NP", text:"Nepal"},
                    { value:"NL", text:"Netherlands"},
                    { value:"NC", text:"New Caledonia"},
                    { value:"NZ", text:"New Zealand"},
                    { value:"NI", text:"Nicaragua"},
                    { value:"NE", text:"Niger"},
                    { value:"NG", text:"Nigeria"},
                    { value:"NU", text:"Niue"},
                    { value:"NF", text:"Norfolk Island"},
                    { value:"MP", text:"Northern Mariana Islands"},
                    { value:"NO", text:"Norway"},
                    { value:"OM", text:"Oman"},
                    { value:"PK", text:"Pakistan"},
                    { value:"PW", text:"Palau"},
                    { value:"PS", text:"Palestinian Territory, Occupied"},
                    { value:"PA", text:"Panama"},
                    { value:"PG", text:"Papua New Guinea"},
                    { value:"PY", text:"Paraguay"},
                    { value:"PE", text:"Peru"},
                    { value:"PH", text:"Philippines"},
                    { value:"PN", text:"Pitcairn"},
                    { value:"PL", text:"Poland"},
                    { value:"PT", text:"Portugal"},
                    { value:"PR", text:"Puerto Rico"},
                    { value:"QA", text:"Qatar"},
                    { value:"RE", text:"Réunion"},
                    { value:"RO", text:"Romania"},
                    { value:"RU", text:"Russian Federation"},
                    { value:"RW", text:"Rwanda"},
                    { value:"BL", text:"Saint Barthélemy"},
                    { value:"SH", text:"Saint Helena, Ascension and Tristan da Cunha"},
                    { value:"KN", text:"Saint Kitts and Nevis"},
                    { value:"LC", text:"Saint Lucia"},
                    { value:"MF", text:"Saint Martin (French part)"},
                    { value:"PM", text:"Saint Pierre and Miquelon"},
                    { value:"VC", text:"Saint Vincent and the Grenadines"},
                    { value:"WS", text:"Samoa"},
                    { value:"SM", text:"San Marino"},
                    { value:"ST", text:"Sao Tome and Principe"},
                    { value:"SA", text:"Saudi Arabia"},
                    { value:"SN", text:"Senegal"},
                    { value:"RS", text:"Serbia"},
                    { value:"SC", text:"Seychelles"},
                    { value:"SL", text:"Sierra Leone"},
                    { value:"SG", text:"Singapore"},
                    { value:"SX", text:"Sint Maarten (Dutch part)"},
                    { value:"SK", text:"Slovakia"},
                    { value:"SI", text:"Slovenia"},
                    { value:"SB", text:"Solomon Islands"},
                    { value:"SO", text:"Somalia"},
                    { value:"ZA", text:"South Africa"},
                    { value:"GS", text:"South Georgia and the South Sandwich Islands"},
                    { value:"SS", text:"South Sudan"},
                    { value:"ES", text:"Spain"},
                    { value:"LK", text:"Sri Lanka"},
                    { value:"SD", text:"Sudan"},
                    { value:"SR", text:"Suriname"},
                    { value:"SJ", text:"Svalbard and Jan Mayen"},
                    { value:"SZ", text:"Swaziland"},
                    { value:"SE", text:"Sweden"},
                    { value:"CH", text:"Switzerland"},
                    { value:"SY", text:"Syrian Arab Republic"},
                    { value:"TW", text:"Taiwan, Province of China"},
                    { value:"TJ", text:"Tajikistan"},
                    { value:"TZ", text:"Tanzania, United Republic of"},
                    { value:"TH", text:"Thailand"},
                    { value:"TL", text:"Timor-Leste"},
                    { value:"TG", text:"Togo"},
                    { value:"TK", text:"Tokelau"},
                    { value:"TO", text:"Tonga"},
                    { value:"TT", text:"Trinidad and Tobago"},
                    { value:"TN", text:"Tunisia"},
                    { value:"TR", text:"Turkey"},
                    { value:"TM", text:"Turkmenistan"},
                    { value:"TC", text:"Turks and Caicos Islands"},
                    { value:"TV", text:"Tuvalu"},
                    { value:"UG", text:"Uganda"},
                    { value:"UA", text:"Ukraine"},
                    { value:"AE", text:"United Arab Emirates"},
                    { value:"GB", text:"United Kingdom"},
                    { value:"US", text:"United States"},
                    { value:"UM", text:"United States Minor Outlying Islands"},
                    { value:"UY", text:"Uruguay"},
                    { value:"UZ", text:"Uzbekistan"},
                    { value:"VU", text:"Vanuatu"},
                    { value:"VE", text:"Venezuela, Bolivarian Republic of"},
                    { value:"VN", text:"Viet Nam"},
                    { value:"VG", text:"Virgin Islands, British"},
                    { value:"VI", text:"Virgin Islands, U.S."},
                    { value:"WF", text:"Wallis and Futuna"},
                    { value:"EH", text:"Western Sahara"},
                    { value:"YE", text:"Yemen"},
                    { value:"ZM", text:"Zambia"},
                    { value:"ZW", text:"Zimbabwe"}
    ]
 
    for(var i = 0; i < options.length; i++){
        this.selectCountry.push(options[i])
      }
    },
    confermaReg() {
        this.saveReg=true;
        console.log("cliccato confermaReg! " + this.code);
        if (!this.validation_code) return
        Auth.confirmSignUp(this.email,this.code).then(
            user => {
                console.log("signup complete! ", user);  
                this.signedIn=false;
                this.confirmCode=true;
                //this.$store.commit('firstLogin',{});
            }
        ).catch(
          err => {
              console.log(err);
              this.alertMessage=this.$t("signup."+err.code);
              this.showAlert();
          }
        )
    },
    gotoLogin(){
        this.$store.commit('firstLogin',{});
    },
    registrati() {
      this.saveSubmit=true;
      if (!this.validation_name || !this.validation_surname || !this.validation_email || !this.validation_password || !this.validation_passwordConfirm) return; 
      Auth.signUp({
          username: this.email, password: this.password,attributes: {
              name: this.name,
              'custom:surname': this.surname,
              email: this.email,
              'custom:marketing': this.chk_marketing+"_"+this.chk_profiling+"_"+this.chk_thirdParts
          }
      })
      .then(user => {
        var clientData={};
        
        if (this.$store.state.invite!=null && this.$store.state.inviteType=="client")
        {
          if(this.picked=="company")
          {
            clientData.businessName =this.userbusinessName;
            clientData.piva=this.userPiva;
          }
          clientData.name=this.name;
          clientData.surname=this.surname;
          clientData.phone=this.userPhone;
          clientData.street=this.userStreet;
          clientData.housenumber=this.userNumber;
          clientData.city=this.userCity;
          clientData.cap=this.userCap;
          clientData.prov=this.userProv;
          clientData.country=this.userCountry;
          this.$store.state.clientRegistrationData=clientData;
        }
        console.log("user-->",user);
        console.log("dataClient-->",this.$store.state.clientRegistrationData);
        this.currUser = user;
        //this.$store.commit('setLoggedUser',user);
        this.signedIn = true;
        //this.$router.push('/');
      })
      .catch(err => {
        console.log(err);
        this.alertMessage=this.$t("signup."+err.code);
        this.showAlert();
      });

    },
    countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown
      },
    showAlert() {
        this.dismissCountDown = this.dismissSecs
      }
  }
}
</script>


<style scoped>

#icon{
  display: inline-block;
  border-radius: 60px;
  border: 2px solid #009DE0;
  padding: 0.5em 0.6em;
}

@media screen and (max-width: 767px) {
  .loginPage {
    height: 100%;
    margin-top: 0px;
  }

  .loginPanel {
    margin-left: 5%;
    margin-right: 5%;
    margin-top: 20%;
    padding-top: 10px;
    border-radius: 10px;
  }

  .pwdButton {
    color: #000000;
    font-size: 16px;
  }

}

.auth {
  margin: 0 auto;
  width: 460px;
}
</style>